import { useEffect, useState } from "react";

import {
  collection,
  getDocs,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

function BrSoloScreen() {
  const [data, setData] = useState([]);
  const [tab, setTab] = useState("upcoming");

  const navigate = useNavigate();

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const snap = await getDocs(collection(db, "br_tournaments"));

    const list = snap.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }));

    setData(list);
  };

  // 🔥 DELETE
  

  const now = new Date();

  const filtered = data.filter((t) => {
    const time = t.time?.seconds
      ? new Date(t.time.seconds * 1000)
      : new Date();

    return tab === "upcoming" ? time >= now : time < now;
  });

  return (
    <div style={container}>
      <h1>🔥 BR Solo Full Map</h1>

      {/* CREATE */}
      <button style={createBtn} onClick={() => navigate("/create-br-solo")}>
        ➕ Create Tournament
      </button>

      {/* TABS */}
      <div style={tabs}>
        <button
          style={tabBtn(tab === "upcoming")}
          onClick={() => setTab("upcoming")}
        >
          Upcoming
        </button>

        <button
          style={tabBtn(tab === "completed")}
          onClick={() => setTab("completed")}
        >
          Completed
        </button>
      </div>

      {/* LIST */}
      {filtered.map((t) => (
        <Card key={t.id} t={t}  navigate={navigate} />
      ))}
    </div>
  );
}

/* ================= CARD ================= */
function Card({ t, deleteTournament, navigate }) {
  const [players, setPlayers] = useState(0);
  const [winners, setWinners] = useState([]);

  // 🔥 PARTICIPANTS
  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, `br_tournaments/${t.id}/participants`),
      (snap) => setPlayers(snap.size)
    );

    return () => unsub();
  }, [t.id]);

  // 🔥 WINNERS
  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, `br_tournaments/${t.id}/winners`),
      (snap) => {
        const list = snap.docs.map((d) => d.data());
        setWinners(list);
      }
    );

    return () => unsub();
  }, [t.id]);

  const time = t.time?.seconds
    ? new Date(t.time.seconds * 1000)
    : null;

  const isCompleted = time ? time < new Date() : false;

  return (
    <div style={card}>
      <h3>{t.title}</h3>

      <p>📍 {t.map}</p>
      <p>👥 {t.totalSpots} / {players}</p>

      <p>
        ⏰ {time ? time.toLocaleString() : "No Time"}
      </p>

      {t.prizePool > 0 && (
        <p style={{ color: "green" }}>💰 ₹{t.prizePool}</p>
      )}

      {t.perKill > 0 && (
        <p style={{ color: "orange" }}>
          ⚔ ₹{t.perKill} / kill
        </p>
      )}

      {/* 🔥 WINNERS */}
      {winners.length > 0 && (
        <div style={winnerBox}>
          <b>🏆 Winners:</b>

          {winners.slice(0, 2).map((w, i) => (
            <p key={i}>
              {w.teamName} - {w.kills || w.prizeDistribution?.totalKills} kills
              (₹{w.totalEarnings || w.prizeDistribution?.totalPrize})
            </p>
          ))}

          {winners.length > 2 && (
            <p>+ {winners.length - 2} more</p>
          )}
        </div>
      )}

      {/* ACTIONS */}
      <div style={actions}>
        {!isCompleted && (
          <>
          <button
    onClick={() =>
      navigate("/edit", {
        state: {
          id: t.id,
          data: t,
          collectionName: "b_tournaments",
        },
      })
    }
  >
    ✏️ Edit
  </button>
           <button
  style={smallBtn}
  onClick={() =>
    navigate("/delete", {
      state: {
        id: t.id,
        data: t,
        collectionName: "be_tournaments",
      },
    })
  }
>
  ❌ Delete
</button>

           <button
  onClick={() =>
    navigate("/add-room", {
      state: {
        tournamentId: t.id,
        collectionType: "br_tournaments", // 🔥 change according to screen
      },
    })
  }
>
  🏠 Room
</button>
          </>
        )}

       <button
  disabled={t.winnerDeclared}
  onClick={async () => {
    // 🔥 participants fetch
    const snap = await getDocs(
      collection(db, "br_tournaments", t.id, "participants") // 👈 change per screen
    );

    const participantsData = snap.docs.map((d) => d.data());

    navigate("/decide-winner", {
      state: {
        tournamentId: t.id,
        participants: participantsData,
        tournamentData: t,
        collectionType: "br_tournaments", // 👈 IMPORTANT change per type
      },
    });
  }}
  style={{
    padding: "6px 10px",
    borderRadius: 6,
    border: "none",
    cursor: t.winnerDeclared ? "not-allowed" : "pointer",
    background: t.winnerDeclared ? "#16A34A" : "#2563EB",
    color: "#fff",
  }}
>
  {t.winnerDeclared ? "✅ Winner Done" : "🏆 Decide"}
</button>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const container = {
  color: "white",
  padding: 20,
};

const createBtn = {
  background: "green",
  color: "#fff",
  padding: 10,
  border: "none",
  borderRadius: 8,
  marginBottom: 20,
};

const tabs = {
  display: "flex",
  gap: 10,
  marginBottom: 20,
};

const tabBtn = (active) => ({
  padding: "8px 14px",
  borderRadius: 20,
  border: "none",
  background: active ? "#2563EB" : "#1E2235",
  color: "#fff",
});

const card = {
  background: "#1E2235",
  padding: 15,
  borderRadius: 10,
  marginBottom: 12,
};

const actions = {
  marginTop: 10,
  display: "flex",
  gap: 10,
};

const winnerBox = {
  background: "#064e3b",
  padding: 8,
  borderRadius: 8,
  marginTop: 8,
};
const smallBtn = {
  padding: "6px 10px",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
};

export default BrSoloScreen;